export const proxiesPermission = {
    proxiesView: "proxy.view",
    proxiesCreate: "proxy.create",
    proxiesDelete: "proxy.delete",
    proxiesTagsView: "proxy-tag.view",
    proxiesTagsAttach: "proxy-tag.attach",
    proxiesTagsDetach: "proxy-tag.detach",
};
